export const HTTP_PARTIAL = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ''
}`;

export const PLATFORMS = ['whatsapp', 'facebook', 'twitter'];

export const STATES = {
  active: 'Active',
  pause: 'Pause',
};

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const MIN_YEAR = 2019;

export const LANGUAGES = [
  {
    key: 'en',
    value: 'english',
  },
  {
    key: 'fr',
    value: 'french',
  },
  {
    key: 'nl',
    value: 'dutch',
  },
];
